import { render, staticRenderFns } from "./BaseInputCheckox.vue?vue&type=template&id=4a5d3a48&scoped=true&"
import script from "./BaseInputCheckox.vue?vue&type=script&lang=js&"
export * from "./BaseInputCheckox.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputCheckox.vue?vue&type=style&index=0&id=4a5d3a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d3a48",
  null
  
)

export default component.exports